var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg333Mbf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.565 107.062H72.565V147.062H32.565z",
    transform: "rotate(-45.001 52.565 127.065)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.164 67.464H112.16300000000001V107.465H72.164z",
    transform: "rotate(-45.001 92.164 87.467)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.761 27.866H151.76V67.86699999999999H111.761z",
    transform: "rotate(-45.001 131.764 47.868)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.305 146.519H112.30600000000001V186.52H72.305z",
    transform: "rotate(-45.001 92.304 166.52)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.903 106.922H151.904V146.921H111.903z",
    transform: "rotate(-45.001 131.899 126.922)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.501 67.323H191.501V107.323H151.501z",
    transform: "rotate(-45.001 171.5 87.326)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.974 186.046H151.973V226.047H111.974z",
    transform: "rotate(-45.001 131.976 206.052)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M151.572 146.448H191.571V186.449H151.572z",
    transform: "rotate(-45.001 171.566 166.449)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M191.17 106.85H231.171V146.851H191.17z",
    transform: "rotate(-45.001 211.164 126.852)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.458 341.045H72.459V381.046H32.458z",
    transform: "rotate(-45.001 52.458 361.054)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.056 301.447H112.055V341.448H72.056z",
    transform: "rotate(-45.001 92.057 321.456)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.654 261.849H151.653V301.84999999999997H111.654z",
    transform: "rotate(-45.001 131.656 281.857)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.197 380.502H112.19800000000001V420.503H72.197z",
    transform: "rotate(-45.001 92.194 400.505)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M111.796 340.905H151.796V380.90299999999996H111.796z",
    transform: "rotate(-45.001 131.78 360.895)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M151.394 301.307H191.393V341.30600000000004H151.394z",
    transform: "rotate(-45.001 171.384 321.305)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.867 420.029H151.865V460.029H111.867z",
    transform: "rotate(-45.001 131.862 440.033)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M151.465 380.43H191.464V420.431H151.465z",
    transform: "rotate(-45.001 171.454 400.428)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M191.062 340.833H231.06300000000002V380.834H191.062z",
    transform: "rotate(-45.001 211.052 360.831)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M443.368 249.918c4.93-76.658 73.936-190.163-58.732-190.163-111.139 0-118.596 96.192-118.596 190.163 0 84.969 4.043 186.586 106.525 190.163 142.873 4.986 76.282-104.975 70.803-190.163z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg333Mbf);
export default __webpack_public_path__ + "static/media/333mbf.e504bc651026556d38e45494cd5a2d0d.svg";
export { ForwardRef as ReactComponent };